import {makeStyles} from "@material-ui/core/styles";
import {createStyles} from "@material-ui/core";

export const molabsStyles = makeStyles((theme) => createStyles({
    image: {
        maxWidth: '100%',
        maxHeight: '180px'
    },
    flexContainer: {
        display: 'flex',
        width: '100%',
    },
    flexGrow: {
        flexGrow: 1,
    },
    subHeadline: {
        paddingTop: theme.spacing(3),
    },
    marginBottom: {
        marginBottom: theme.spacing(4),
    },
    contentContainer: {
        [theme.breakpoints.down('sm')]: {
            padding: theme.spacing(2)
        },
        padding: theme.spacing(5)
    },
    link: {
        color: theme.palette.text.primary,
        textDecoration: 'none',
    },
    contactForm: {
        margin: theme.spacing(5)
    },
    contactBackground: {
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'left top',
    },
    contactAddress: {
        position: 'relative',
        backgroundColor: theme.palette.text.secondary,
        display: 'inline-block',
        padding: theme.spacing(2),
        top: '40%',
        left: '40%',
    },
    fileInputContainer: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(1),
    },
    fileInput: {
        height: 'auto'
    }
}));
